import { Component, OnInit, ChangeDetectionStrategy, inject, DOCUMENT } from '@angular/core';
import { WindowService } from '@shared/window';
import { RouterLink } from '@angular/router';
import { LocalizePipe } from '../../../i18n/pipes/lozalize.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-cookies-policy',
    templateUrl: './cookies-policy.component.html',
    styleUrls: ['./cookies-policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, LocalizePipe, TranslatePipe],
})
export class CookiesPolicyComponent implements OnInit {
    private windowService = inject(WindowService);
    private document = inject(DOCUMENT);

    ngOnInit(): void {
        this.windowService.scrollTo(0);
    }

    get currentDomain(): string {
        return this.document.location.origin;
    }
}
